export interface IRequestDelayData {
  modelRequestDelay: number;
  bigModelRequestDelay: number;
  defaultNumberOfAttempts: number;
}

export const MODEL_REQUEST_DELAY = 1000;
export const BIG_MODEL_REQUEST_DELAY = 5000;
export const DEFAULT_NUMBER_OF_ATTEMPTS = 5;
